import { apiSlice } from "../apiSlice";

/* ------------------ API Slice ------------------ */
export const downloadTemplateSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* -------- GET TEMPLATE FILE URL OPTIONS -------- */
    getDownloadTemplateOptions: builder.query({
      query: () => "/bulk_deals/spares/download_template_file_url",

      transformResponse: (response) => response.data,

      providesTags: [{ type: "DownloadTemplate", id: "LIST" }],
    }),
  }),
});

/* ------------------ Hooks ------------------ */
export const { useGetDownloadTemplateOptionsQuery } = downloadTemplateSlice;